import {addClass, removeClass} from "./_classesHelper";

class SideNav {
  constructor() {
    this.languageSwitch = document.querySelector(".sidenav__language-switcher");
    this.listWrapperString = ".sidenav__subnav-list";
    this.listWrapperString2 = ".child-menu.dropdown-menu";
    this.navHasChildrenClass = "js-has-children";
    this.navHasChildrenClass2 = "dropdown-toggle";
    this.listWrapper = [...document.querySelectorAll(this.listWrapperString)];
    this.listWrapper2 = [...document.querySelectorAll(this.listWrapperString2)];
    this.openButton = document.querySelector(".js-burger-open");
    this.closeButton = document.querySelector(".js-burger-close");
    this.linksMainNav = [...document.querySelectorAll(`.js-sidenav__link`)];
    this.linksSecondNav = [
      ...document.querySelectorAll(".sidenav__wrapper--second .nav-link"),
    ];
    this.allNavLinks = this.linksMainNav.concat(this.linksSecondNav); //concat links for same functionality.
    this.backdrop = document.querySelector(".js-backdrop");
    this.body = document.querySelector("body");
    //the classnames
    this.menuIsVisibleClass = "side-menu-is-visible-js";
    this.menuSecondLevelVisibleClass = "submenu-is-visible-js";
    this.isVisibleClass = "children-are-visible-js";
    this.subnavIsSlidedInClass = "is-slided-in";
    this.subnavWrapperClass = ".sidenav__subnav-wrapper-js";
    this.subnavCloseButton = ".sidenav__subnav-back-btn-js";
    this.subnavCopy = "subnav__first-element-js";
    this.aria = "aria-expanded";
    this.menuSecondLevelExpandedClass = "submenu-is-expanded";
    this.breakpoint = "(min-width: 769px)";
    this.breakpointLarge = "(max-width: 1400px)";
    this.mediaQuery = window.matchMedia(this.breakpoint);
    this.mediaQuery2 = window.matchMedia(
      `${this.breakpoint} and ${this.breakpointLarge}`
    );

    if (this.openButton) {
      this.init();
    }

  }

  init() {
    this.openButton.addEventListener("click", () => {
      this.openButton.setAttribute('aria-expanded', "true");
      addClass(this.body, this.menuIsVisibleClass);
      //set the focus after the animation
      setTimeout(() => {
        this.closeButton.focus();
      }, 250);
    });

    this.languageSwitch.addEventListener("keydown", (e) => {
      if (e.key === 'Tab' && e.shiftKey === false) {
        this.resetActiveElements();
      }
    });


    this.backdrop.addEventListener("click", () => {
      this.resetActiveElements();
    });

    this.closeButton.addEventListener("click", () => {
      this.resetActiveElements();
    });

    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        this.body.classList.contains(this.menuIsVisibleClass)
      ) {
        this.resetActiveElements();
      }
    });

    this.allNavLinks.forEach((element) => {
      element.addEventListener("mouseenter", (e) => {
        this.bindHoverFunctionBasedOnScreensize(
          e,
          this.mediaQuery,
          this.mediaQuery2,
          element
        );
      });

      element.addEventListener("keydown", (e) => {
        this.bindHoverFunctionBasedOnScreensize(
          e,
          this.mediaQuery,
          this.mediaQuery2,
          element
        );
      });

      element.addEventListener("click", (e) => {
        this.bindClickFunctionBasedOnScreensizes(
          e,
          this.mediaQuery,
          this.mediaQuery2,
          element
        );
      });
    });

    window.addEventListener("resize", (event) => {
      this.mediaQuery = window.matchMedia(this.breakpoint);
      this.mediaQuery2 = window.matchMedia(this.breakpointLarge);
      //check if the sidenav is open, when resizing happens. If it is, close it
      if (
        this.mediaQuery.matches &&
        this.body.classList.contains(this.menuIsVisibleClass)
      ) {
        this.resetActiveElements();
      }
    });
  }

  bindHoverFunctionBasedOnScreensize(event, screensize, screensize2, element) {
    //if screensize == screen; bind screen function, else return
    if (screensize.matches && screensize2.matches) {
      this.openSubnavForScreen(event, element);
      this.addElementToList(element);
    } else if (screensize.matches) {
      this.openSubnavForScreen(event, element);
    } else {
      return;
    }
  }

  bindClickFunctionBasedOnScreensizes(event, screensize, screensize2, element) {
    //if screensize is Mobile-size; bind mobile function, else bind screen function. Sizes for tablet add the top-nav-element to subnav-list
    if (!screensize.matches) {
      this.openSubnavForMobile(event, element);
    } else if (screensize2.matches) {
      if (this.navHasChildren(element)) {
        event.preventDefault();
      }
      this.openSubnavForScreen(event, element);
      this.addElementToList(element);
    } else {
      this.openSubnavForScreen(event, element);
      return;
    }
  }

  openSubnavForScreen(event, el) {
    //if element has children open submenu, otherwise reset all classes for submenues to close them, if it was already open
    if (this.navHasChildren(el)) {
      this.addClassAfterReset(this.allNavLinks, el, this.isVisibleClass);
      addClass(this.body, this.menuSecondLevelVisibleClass);
      // addClass(this.body, this.menuSecondLevelExpandedClass);
    } else {
      removeClass(this.body, this.menuSecondLevelVisibleClass);
      // removeClass(this.body, this.menuSecondLevelExpandedClass);
      this.allNavLinks.forEach((element) => {
        removeClass(element, this.isVisibleClass);
      });
    }
  }

  openSubnavForMobile(event, element) {
    //if Element has Submenu, prevent click and add a container around submenu and let it slide in
    if (this.navHasChildren(element)) {
      event.preventDefault();
      const newElement = this.convertStringToNode(this.makeTemplate(element));
      this.removeNodeFromDom(element.nextElementSibling);
      this.addNodeElementAfter(newElement, element);
      let newElInDom = document.querySelector(this.subnavWrapperClass);

      let backButton = document.querySelector(this.subnavCloseButton);
      setTimeout(() => {
        addClass(newElInDom, this.subnavIsSlidedInClass);
        addClass(newElInDom, this.menuSecondLevelExpandedClass);
      }, 300);

      backButton.addEventListener(
        "click",
        this.resetSubNavMobile.bind(this, newElInDom)
      );
    }
  }

  addElementToList(element) {
    const sibling = element.nextElementSibling;
    const addedEl = sibling?.querySelector(`.${this.subnavCopy}`);
    if (!addedEl && sibling) {
      const copy = element.cloneNode(true);
      let listEl = document.createElement("li");
      listEl.classList.add(this.subnavCopy);
      //if There is allready an active Element in the subnav-list, remove the active class from the copied link of the parent-page. So it shows only the actual page the user is as active.
      if (this.activeElementExists(sibling)) {
        removeClass(copy, "active");
        addClass(copy, "not-active"); //need to add a class because the liferay-navigation has the activ-class only in the parent
      }
      listEl.appendChild(copy);
      sibling.prepend(listEl);
    }
  }

  removeElementFromList(element) {
    const sibling = element.nextElementSibling;
    if (sibling) {
      const addedEl = sibling.querySelector(`.${this.subnavCopy}`);
      if (addedEl) {
        sibling.removeChild(addedEl);
      }
    }
  }

  activeElementExists(element) {
    const active = element.querySelector(".active");
    return active ? true : false;
  }

  resetSubNavMobile(element) {
    removeClass(element, this.subnavIsSlidedInClass);
    removeClass(element, this.menuSecondLevelExpandedClass);
    setTimeout(() => {
      this.replaceGeneratedElements(element);
    }, 300);
  }

  replaceGeneratedElements(el) {
    let innerList =
      el.querySelector(this.listWrapperString) ||
      el.querySelector(this.listWrapperString2);
    this.addNodeElementAfter(innerList, el.previousElementSibling);
    this.removeNodeFromDom(el);
  }

  makeTemplate(element) {
    const txt = element.querySelector("span").innerHTML;
    const list = element.nextElementSibling.outerHTML;
    let template = `<div class="sidenav__subnav-wrapper-js">
                      <div class="sidenav__subnav-container-js">
                        <button class="sidenav__subnav-back-btn-js"></button>
                        <div class="sidenav__subnav-top-link-js">${element.outerHTML}</div>
                        ${list}
                      </div>
                    </div>`;
    return template;
  }

  convertStringToNode(htmlString) {
    const div = document.createElement("div");
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  }

  htmlToElement(parentNode, html) {
    if (parentNode) {
      parentNode.innerHTML = html;
      return parentNode;
    }
    return;
  }

  removeNodeFromDom(el) {
    el.parentNode.removeChild(el);
  }

  addNodeElementAfter(elementToAdd, elementBeforeToAdd) {
    elementBeforeToAdd.parentNode.insertBefore(
      elementToAdd,
      elementBeforeToAdd.nextElementSibling
    );
  }

  resetActiveElements() {
    this.openButton.setAttribute('aria-expanded', "false");
    removeClass(this.body, this.menuIsVisibleClass);
    removeClass(this.body, this.menuSecondLevelVisibleClass);
    removeClass(this.body, this.menuSecondLevelExpandedClass);
    const allSubnavLinksGenerated = [
      ...document.querySelectorAll(this.subnavWrapperClass),
    ];

    this.allNavLinks.forEach((element) => {
      removeClass(element, this.isVisibleClass);
      this.removeElementFromList(element);
    });
    if (allSubnavLinksGenerated.length > 0) {
      allSubnavLinksGenerated.forEach((element) => {
        this.replaceGeneratedElements(element);
      });
    }
    this.openButton.focus();
  }

  addClassAfterReset(resetArray, el, className) {
    resetArray.forEach((el) => {
      removeClass(el, className);
      el.setAttribute(this.aria, false);
      removeClass(el.parentNode, this.menuSecondLevelExpandedClass)
    });
    addClass(el, className);
    el.setAttribute(this.aria, true);
    addClass(el.parentNode, this.menuSecondLevelExpandedClass)
  }

  navHasChildren(element) {
    return (
      element.classList.contains(this.navHasChildrenClass2) ||
      element.classList.contains(this.navHasChildrenClass)
    );
  }
}

export default SideNav;
